import { gql } from "@apollo/client";
import { useMutation, useQuery } from "@apollo/client/react";
import { Loader } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useParams } from "react-router-dom";
import { Tournament } from "../../../../../gql/graphql";
import { CreationForm } from "../../../components/form/CreationForm";
import { constructCustomFieldsForm } from "../../../components/form/CustomFieldsForm";
import { PageHeader } from "../../../components/PageHeader";

export const UpdateTournamentCustomFields = () => {
  const tournamentId = useParams().tournamentId;
  const { loading, data } = useQuery<{ tournament: Tournament }>(
    gql`
      query ($id: ID!) {
        tournament(id: $id) {
          configuration {
            customFields {
              name
              type
              property
              order
              unique
              required
              public
              editability
              visibility
            }
          }
        }
      }
    `,
    { variables: { id: tournamentId }, skip: !tournamentId },
  );
  const [updateTournament] = useMutation<any>(gql`
    mutation (
      $id: ID!
      $configuration: UpdateTournamentConfigurationOrImportFromIdInput!
    ) {
      updateTournament(id: $id, input: { configuration: $configuration }) {
        id
      }
    }
  `);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="wp-fade-in">
      <PageHeader
        title="Custom Fields"
        showBackButton
        showBreadcrumbs={false}
      />
      <CreationForm
        title="Update custom fields"
        schemaDefinition={{
          customFields: constructCustomFieldsForm({
            defaultValue: data?.tournament?.configuration?.customFields,
            label: "Custom fields",
          }),
        }}
        onSubmit={async (data) => {
          await updateTournament({
            variables: {
              id: tournamentId,
              configuration: {
                configuration: { customFields: data.customFields },
              },
            },
          }).then((data) => {
            if (data?.error) {
              throw new Error(data.error.message);
            }
          });
          notifications.show({
            title: "Tournament updated",
            message: "The tournament has been updated",
            color: "green",
            autoClose: 3000,
          });
        }}
      />
    </div>
  );
};
